/* eslint-disable */
import axios from "axios";
import React, { useEffect, useState } from "react";
import Navbar from "../Pages/Navbar";

import {
  useDisclosure,
  IconButton,
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Spinner,
  Text,
  keyframes,
  useToast,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  useColorModeValue
} from "@chakra-ui/react";

import { useDispatch, useSelector, useStore } from "react-redux";
import { loginFetch } from "../Redux/UserReducer/action";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showToast } from "./SignUp";
import { useModalToast } from "../context/GlobalModalToast";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const userStore = useSelector((store) => store.UserReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useModalToast();
  const [showForgot, setShowForgot] = useState(false);
  const [forgotStep, setForgotStep] = useState(1);
  const tabListBg = useColorModeValue("purple.50", "gray.800");
  const tabListBorder = useColorModeValue("purple.200", "gray.700");
  const tabInactiveColor = useColorModeValue("purple.800", "gray.300");

  const from = location.state?.from?.pathname ? `${location.state.from.pathname}${location.state.from.search || ""}` : null;
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotOtp, setForgotOtp] = useState("");
  const [forgotNewPassword, setForgotNewPassword] = useState("");
  const [isSendingForgot, setIsSendingForgot] = useState(false);

  async function handleSendForgotCode() {
    if (!forgotEmail) {
      showToast({ toast, message: "Please enter your email", color: "red" });
      return;
    }
    setIsSendingForgot(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, { email: forgotEmail });
      showToast({ toast, message: res.data.message || "Code sent!", color: "green" });
      setForgotStep(2);
    } catch (err) {
      showToast({ toast, message: err.response?.data?.message || "Failed to send code", color: "red" });
    } finally {
      setIsSendingForgot(false);
    }
  }

  async function handleResetPassword() {
    if (!forgotOtp || !forgotNewPassword) {
      showToast({ toast, message: "Please enter both the OTP code and new password", color: "red" });
      return;
    }
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, {
        email: forgotEmail,
        otp: forgotOtp,
        newPassword: forgotNewPassword
      });
      showToast({ toast, message: "Password updated successfully!", color: "green" });

      sessionStorage.setItem("isSsoSession", "true");
      localStorage.setItem("user", JSON.stringify({
        token: res.data.token,
        email: res.data.user.email,
        name: res.data.user.fullName,
        role: res.data.user.role,
        isAuth: true,
        userId: res.data.user._id,
        user: res.data.user,
        companyId: res.data.user.companyId || "",
        companyName: res.data.user.companyName || "",
        hasCompletedLna: res.data.user.hasCompletedLna !== undefined ? res.data.user.hasCompletedLna : false
      }));

      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          token: res.data.token,
          user: res.data.user
        }
      });

      setShowForgot(false);
      setForgotStep(1);
    } catch (err) {
      showToast({ toast, message: err.response?.data?.message || "Password reset failed", color: "red" });
    }
  }

  function handleInput(e) {
    const { value, name } = e.target;
    setForm({ ...form, [name]: value });
  }

  async function handleLogin() {
    if (!form.email || !form.password) {
      showToast({ toast, message: 'Please fill all fields', color: 'red' });
      return;
    }
    const trimmedForm = {
      email: form.email.trim(),
      password: form.password.trim()
    };
    try {
      await dispatch(loginFetch(trimmedForm));
    } catch (err) {
      showToast({ toast, message: userStore?.isError || 'Login Failed', color: 'red' });
    }
  }

  useEffect(() => {
    if (userStore.isAuth) {
      if (from) {
        navigate(from, { replace: true });
      } else {
        if (userStore?.role === 'user' || userStore?.role === 'employee') navigate("/home");
        else if (userStore?.role === "admin" || userStore?.role === "super_admin") navigate("/admin/dashboard");
        else if (userStore?.role === 'instructor') navigate("/teacher-dashboard");
      }
    }
  }, [userStore?.isAuth, userStore?.role, navigate, from]);

  if (showForgot) {
    return (
      <Box minH="100vh" bg="var(--background)">
        <Navbar />
        <Flex justify="center" align="center" pt="150px" px={4}>
          <Box className="glass-card" p={{ base: 8, md: 12 }} w="full" maxW="500px" transition="all 0.3s">
            <Heading size="xl" fontWeight="800" mb={2} letterSpacing="-1px">
              Reset Password
            </Heading>
            <Text color="var(--text-muted)" mb={8}>
              {forgotStep === 1
                ? "Enter your corporate email address to receive a secure password reset OTP"
                : "Enter the OTP code from your email and your new password"}
            </Text>

            <Stack spacing={6}>
              {forgotStep === 1 ? (
                <>
                  <Box>
                    <Text fontSize="sm" fontWeight="600" mb={2} ml={1}>Email Address</Text>
                    <Input
                      placeholder="name@example.com"
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                      h="56px"
                      borderRadius="xl"
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                    />
                  </Box>
                  <Button
                    bgGradient="linear(to-r, purple.500, blue.500)"
                    color="white"
                    h="60px"
                    borderRadius="xl"
                    fontSize="md"
                    fontWeight="700"
                    onClick={handleSendForgotCode}
                    isLoading={isSendingForgot}
                    _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)", transform: "translateY(-2px)" }}
                    _active={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                    transition="all 0.2s"
                  >
                    Send Verification Code
                  </Button>
                </>
              ) : (
                <>
                  <Box>
                    <Text fontSize="sm" fontWeight="600" mb={2} ml={1}>6-Digit Reset Code</Text>
                    <Input
                      placeholder="******"
                      value={forgotOtp}
                      onChange={(e) => setForgotOtp(e.target.value)}
                      h="56px"
                      borderRadius="xl"
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                    />
                  </Box>
                  <Box>
                    <Text fontSize="sm" fontWeight="600" mb={2} ml={1}>New Password</Text>
                    <Input
                      type="password"
                      placeholder="••••••••"
                      value={forgotNewPassword}
                      onChange={(e) => setForgotNewPassword(e.target.value)}
                      h="56px"
                      borderRadius="xl"
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                    />
                  </Box>
                  <Button
                    bgGradient="linear(to-r, purple.500, blue.500)"
                    color="white"
                    h="60px"
                    borderRadius="xl"
                    fontSize="md"
                    fontWeight="700"
                    onClick={handleResetPassword}
                    _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)", transform: "translateY(-2px)" }}
                    _active={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                    transition="all 0.2s"
                  >
                    Reset & Sign In
                  </Button>
                </>
              )}

              <Button variant="ghost" color="var(--primary)" onClick={() => { setShowForgot(false); setForgotStep(1); }}>
                ← Back to standard login
              </Button>
            </Stack>
          </Box>
        </Flex>
      </Box>
    );
  }

  return (
    <Box minH="100vh" bg="var(--background)">
      <Navbar />
      <Flex justify="center" align="center" pt="150px" px={4}>
        <Box
          className="glass-card"
          p={{ base: 8, md: 12 }}
          w="full"
          maxW="500px"
          transition="all 0.3s"
        >
          <Heading size="xl" fontWeight="800" mb={2} letterSpacing="-1px">
            Welcome back
          </Heading>
          <Text color="var(--text-muted)" mb={8}>
            Enter your credentials to access your account
          </Text>



          <Stack spacing={6}>
            <Box>
              <Text fontSize="sm" fontWeight="600" mb={2} ml={1}>Email Address</Text>
              <Input
                name="email"
                placeholder="name@example.com"
                value={form.email}
                onChange={handleInput}
                h="56px"
                borderRadius="xl"
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                _focus={{ borderColor: "var(--primary)", boxShadow: "0 0 0 1px var(--primary)" }}
              />
            </Box>

            <Box>
              <Flex justify="space-between" align="center" mb={2} ml={1}>
                <Text fontSize="sm" fontWeight="600">Password</Text>
                <Text
                  fontSize="xs"
                  color="var(--primary)"
                  fontWeight="600"
                  cursor="pointer"
                  onClick={() => setShowForgot(true)}
                >
                  Forgot password?
                </Text>
              </Flex>
              <Input
                type="password"
                name="password"
                placeholder="••••••••"
                value={form.password}
                onChange={handleInput}
                h="56px"
                borderRadius="xl"
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                _focus={{ borderColor: "var(--primary)", boxShadow: "0 0 0 1px var(--primary)" }}
              />
            </Box>

            <Button
              bgGradient="linear(to-r, purple.500, blue.500)"
              color="white"
              h="60px"
              borderRadius="xl"
              fontSize="md"
              fontWeight="700"
              onClick={handleLogin}
              isLoading={userStore.loading}
              _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)", transform: "translateY(-2px)" }}
              _active={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
              transition="all 0.2s"
            >
              Sign In
            </Button>


          </Stack>
        </Box>
      </Flex>    </Box>
  );
};

export default Login;
